module.exports = __webpack_public_path__ + "img/wide-mobile.svg.4bcd6d34.png";